import React, { useState } from 'react';
import '../styles/tsumugi-design.css';
import '../styles/components/TsumugiSample.css';

/**
 * Tsumugi Design Sample Page
 * つむぎデザインルール v1.0 準拠
 */
const TsumugiSample = () => {
  const [mood, setMood] = useState(null);
  const [progress] = useState(70);

  return (
    <div data-tsumugi="true">
      {/* Header with Gradient */}
      <div className="tsumugi-header">
        <h1 className="tsumugi-h1">つむぎと一緒に、紡ごう</h1>
        <p className="tsumugi-caption">
          毎日の小さな記録が、あなたの軌跡になる
        </p>
      </div>

      <div className="tsumugi-container">

        {/* 今日の気分 */}
        <section className="tsumugi-section">
          <div className="tsumugi-card-white">
            <h2 className="tsumugi-h2">今日の気分を教えてね</h2>
            <p className="tsumugi-caption tsumugi-sample__caption-spaced">
              タップするだけで記録できます
            </p>

            <div className="tsumugi-mood-grid">
              <button
                className="tsumugi-mood-btn good"
                onClick={() => setMood('良い')}
              >
                <div className="emoji">😊</div>
                <div className="label">良い</div>
                <div className="sublabel">絶好調</div>
              </button>

              <button
                className="tsumugi-mood-btn normal"
                onClick={() => setMood('普通')}
              >
                <div className="emoji">😐</div>
                <div className="label">普通</div>
                <div className="sublabel">まあまあ</div>
              </button>

              <button
                className="tsumugi-mood-btn bad"
                onClick={() => setMood('辛い')}
              >
                <div className="emoji">😢</div>
                <div className="label">辛い</div>
                <div className="sublabel">無理しない</div>
              </button>
            </div>

            {mood && (
              <div className="tsumugi-sample__mood-confirmation">
                <p className="tsumugi-body">
                  「<strong>{mood}</strong>」を記録しました
                </p>
              </div>
            )}
          </div>
        </section>

        {/* チャレンジ進捗 */}
        <section className="tsumugi-section">
          <div className="tsumugi-card">
            <h3 className="tsumugi-h3">10日チャレンジ</h3>
            <p className="tsumugi-caption tsumugi-sample__caption-spaced">
              少しずつ、紡いでいこう
            </p>

            <div className="tsumugi-progress">
              <div className="tsumugi-progress-fill" style={{ width: `${progress}%` }}></div>
            </div>

            <div className="tsumugi-progress-text">
              あと<span className="num">3</span>日で達成
            </div>
          </div>
        </section>

        {/* 獲得バッジ */}
        <section className="tsumugi-section">
          <div className="tsumugi-card-white">
            <h3 className="tsumugi-h3">獲得したバッジ</h3>
            <p className="tsumugi-caption tsumugi-sample__caption-spaced">
              あなたの頑張りの証
            </p>

            <div className="tsumugi-sample__badge-container">
              <span className="tsumugi-tag tsumugi-tag-peach">
                🌸 はじめの一歩
              </span>
              <span className="tsumugi-tag tsumugi-tag-mint">
                🌱 3日連続
              </span>
              <span className="tsumugi-tag tsumugi-tag-lilac">
                💫 バランス達成
              </span>
            </div>
          </div>
        </section>

        {/* つむぎからのメッセージ */}
        <section className="tsumugi-section">
          <div className="tsumugi-message">
            <div className="text">
              食べすぎてしまった日があっても大丈夫。<br />
              明日から少しずつ調整していきましょう。<br />
              あなたのペースで、無理なく続けることが大切です。
            </div>
            <div className="author">
              — つむぎより
            </div>
          </div>
        </section>

        {/* 今日のメモ */}
        <section className="tsumugi-section">
          <div className="tsumugi-card-white">
            <h3 className="tsumugi-h3">今日のメモ</h3>
            <p className="tsumugi-caption tsumugi-sample__caption-spaced">
              気になったことを自由に
            </p>

            <div className="tsumugi-sample__memo-input">
              <input
                type="text"
                className="tsumugi-input"
                placeholder="例: 朝ごはんにサラダを食べました"
              />
            </div>

            <div>
              <textarea
                className="tsumugi-input"
                placeholder="体調や気づいたことなど"
              />
            </div>
          </div>
        </section>

        {/* ボタン */}
        <section className="tsumugi-section">
          <div className="tsumugi-card">
            <h3 className="tsumugi-h3">ボタンスタイル</h3>

            <div className="tsumugi-sample__button-container">
              <button className="tsumugi-btn tsumugi-btn-primary">
                今日の記録を保存する
              </button>

              <button className="tsumugi-btn tsumugi-btn-secondary">
                過去の記録を見る
              </button>

              <button className="tsumugi-btn tsumugi-btn-outline">
                詳しく知る
              </button>
            </div>
          </div>
        </section>

        {/* Empty State */}
        <section className="tsumugi-section">
          <div className="tsumugi-empty">
            <div className="icon">🌸</div>
            <div className="title">まだ記録がありません</div>
            <div className="desc">
              今日から一緒に、<br />
              少しずつ紡いでいきましょう
            </div>
          </div>
        </section>

        {/* タイポグラフィサンプル */}
        <section className="tsumugi-section">
          <div className="tsumugi-card-white">
            <h3 className="tsumugi-h3">タイポグラフィ</h3>

            <div className="tsumugi-sample__typography-container">
              <div>
                <div className="tsumugi-h1">見出し H1（28px）</div>
                <p className="tsumugi-caption">メインタイトル</p>
              </div>

              <div>
                <div className="tsumugi-h2">見出し H2（22px）</div>
                <p className="tsumugi-caption">セクションタイトル</p>
              </div>

              <div>
                <div className="tsumugi-h3">見出し H3（18px）</div>
                <p className="tsumugi-caption">カード見出し</p>
              </div>

              <div>
                <div className="tsumugi-body">本文テキスト（15px、行間1.8）</div>
                <p className="tsumugi-caption">通常の本文</p>
              </div>

              <div>
                <div className="tsumugi-caption">キャプション（13px、行間1.6）</div>
                <p className="tsumugi-caption">補足説明</p>
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default TsumugiSample;
